/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.branding.updateBlob";

export { $nsid };

export const $params = /*#__PURE__*/ l.params();

export type $Params = l.InferOutput<typeof $params>;

export const $input = /*#__PURE__*/ l.jsonPayload({"key":/*#__PURE__*/ l.string(),"broadcaster":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"did"})),"data":/*#__PURE__*/ l.string(),"mimeType":/*#__PURE__*/ l.string(),"width":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"height":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer())});

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>;
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>;

export const $output = /*#__PURE__*/ l.jsonPayload({"success":/*#__PURE__*/ l.boolean()});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Update or create a branding asset blob. Requires admin authorization. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, ["Unauthorized","BlobTooLarge"]);

export { main };

export const $lxm = $nsid;
